import { BOT_DIFFICULTY, MATCH_TYPE } from "../types/match";
import { InOut, X01_ORDER } from "../types/x01";

export enum KEYS {
  SOUND = 'sound',
  LEGS = 'legs',
  SETS = 'sets',
  GESTURE = 'gesture',
  GESTURE_HELP = "gesturehelp",
  BOT_DIFFICULTY = "botdifficulty",
  IN_OUT = "inout",
  X01_GAME = "x01game",
  MATCH_TYPE = "matchtype",
  X01_ORDER = 'x01order',
  NUM_PLAYERS = 'numPlayers',
};


export function setNumPlayersLocalStorage(numPlayers: number) {
  localStorage.setItem(KEYS.NUM_PLAYERS, `${numPlayers}`);
}

export function getNumPlayersLocalStorage(): number {
  let numPlayers: string | number | null = localStorage.getItem(KEYS.NUM_PLAYERS);
  if (!numPlayers) {
    numPlayers = 1
    setNumPlayersLocalStorage(numPlayers);
  }
  return Number(numPlayers);
}

export function setLegLocalStorage(legs: number) {
  localStorage.setItem(KEYS.LEGS, `${legs}`);
}

export function getLegLocalStorage(): number {
  let legs: string | number | null = localStorage.getItem(KEYS.LEGS);
  if (!legs) {
    legs = 1
    setLegLocalStorage(legs);
  }
  return Number(legs);
}

export function setSetLocalStorage(sets: number) {
  localStorage.setItem(KEYS.SETS, `${sets}`);
}

export function getSetLocalStorage(): number {
  let sets: string | number | null = localStorage.getItem(KEYS.SETS);
  if (!sets) {
    sets = 3
    setSetLocalStorage(sets);
  }
  return Number(sets);
}

export function setSoundLocalStorage(sound: boolean) {
  localStorage.setItem(KEYS.SOUND, `${sound}`);
}

export function getSoundLocalStorage(): boolean {
  let sound: string | null = localStorage.getItem(KEYS.SOUND);
  if (sound === null) {
    sound = "false";
    setSoundLocalStorage(false);
  }
  return (sound.toLowerCase() === "true" || sound === "1");
}

export function setGestureLocalStorage(gesture: boolean) {
  localStorage.setItem(KEYS.GESTURE, `${gesture}`);
}

export function getGestureLocalStorage(): boolean {
  let gesture: string | null = localStorage.getItem(KEYS.GESTURE);
  if (gesture === null) {
    gesture = "false";
    setGestureLocalStorage(false);
  }
  return (gesture.toLowerCase() === "true" || gesture === "1");
}

export function setGestureHelpLocalStorage(help: boolean) {
  localStorage.setItem(KEYS.GESTURE_HELP, `${help}`);
}

export function getGestureHelpLocalStorage(): boolean {
  let help: string | null = localStorage.getItem(KEYS.GESTURE_HELP);
  if (!help) {
    setGestureHelpLocalStorage(true);
    return true;
  }
  return help.toLowerCase().trim() === "true";
}

export function setBotDifficultyLocalStorage(difficulty: BOT_DIFFICULTY) {
  localStorage.setItem(KEYS.BOT_DIFFICULTY, difficulty);
}

export function getBotDifficultyLocalStorage(): BOT_DIFFICULTY {
  let difficulty: string | null = localStorage.getItem(KEYS.BOT_DIFFICULTY);
  if (!difficulty) {
    setBotDifficultyLocalStorage(BOT_DIFFICULTY.MEDIUM);
    return BOT_DIFFICULTY.MEDIUM;
  }
  let botDifficulty = BOT_DIFFICULTY.MEDIUM;
  Object.entries(BOT_DIFFICULTY).forEach(([_, value]) => {
    if (value === difficulty) { botDifficulty = value };
  })
  return botDifficulty;
}

export function setInOutLocalStorage(inOut: InOut) {
  localStorage.setItem(KEYS.IN_OUT, inOut);
}

export function getInOutLocalStorage(): InOut {
  let inOutStorage: string | null = localStorage.getItem(KEYS.IN_OUT);
  let inOut = InOut.ANY_IN_DOUBLE_OUT;

  if (!inOutStorage) {
    setInOutLocalStorage(inOut);
    return inOut;
  }
  Object.entries(InOut).forEach(([_, value]) => {
    if (value === inOutStorage) { inOut = value };
  })
  return inOut;
}

export function setX01GameLocalStorage(x01Game: number) {
  localStorage.setItem(KEYS.X01_GAME, `${x01Game}`);
}

export function getX01GameLocalStorage(): number {
  let x01Game: number = parseInt(localStorage.getItem(KEYS.X01_GAME) ?? "NaN");
  if (isNaN(x01Game)) {
    setX01GameLocalStorage(501);
    return 501;
  }
  return x01Game;
}

export function setMatchTypeLocalStorage(matchType: MATCH_TYPE) {
  localStorage.setItem(KEYS.MATCH_TYPE, `${matchType}`);
}

export function getMatchTypeLocalStorage(): MATCH_TYPE {
  let matchTypeStorage: string | null = localStorage.getItem(KEYS.MATCH_TYPE);
  let matchType = MATCH_TYPE.SINGLES;

  if (!matchTypeStorage) {
    setMatchTypeLocalStorage(matchType);
    return matchType;
  }
  Object.entries(MATCH_TYPE).forEach(([_, value]) => {
    if (value === matchType) { matchType = value };
  })
  return matchType;
}

export function setX01OrderLocalStorage(order: X01_ORDER) {
  localStorage.setItem(KEYS.X01_ORDER, order);
}

export function getX01OrderLocalStorage(): X01_ORDER {
  let x01OrderStorage: string | null = localStorage.getItem(KEYS.X01_ORDER);
  let x01Order = X01_ORDER.VERTICAL;
  if (x01OrderStorage === null) {
    setX01OrderLocalStorage(x01Order);
    return x01Order;
  }
  Object.entries(X01_ORDER).forEach(([_, value]) => {
    if (value.toLowerCase() === x01OrderStorage?.toLowerCase()) { x01Order = value };
  })

  return x01Order;
}